import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import CuesheetCueClockStore from 'flux/stores/cuesheet/CuesheetCueClockStore';
import CuesheetCueClockActions from 'flux/actions/cuesheet/CuesheetCueClockActions';
import IntercomActions from 'flux/actions/IntercomActions';
import { ItemRuntimeClock } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';

/**
 * Cue Clock
 *
 */
export default React.createClass({
  displayName: 'CueClock',

  mixins: [PureRenderMixin, Reflux.connect(CuesheetCueClockStore, 'clock')],

  contextTypes: {
    user: React.PropTypes.object,
    router: React.PropTypes.object.isRequired,
  },

  componentWillMount() {
    if (this.props.fullscreen) {
      IntercomActions.hideChat(true);
    }
  },

  componentWillUnmount() {
    if (this.props.fullscreen) {
      IntercomActions.hideChat(false);
    }
  },

  render() {
    const cueClockNode = this._getDisplayNode();

    return (
      <div data-testid="cs-cue-clock" className="cs-cue-clock text-center">
        {cueClockNode}
      </div>
    );
  },

  _getClockReading() {
    const state = this.state.clock;
    return state.get('reading') || 0;
  },

  _getDisplayNode() {
    const { fullscreen, hideDescription } = this.props;

    const duration = this._getClockReading();
    const description = !hideDescription ? 'Item Run Time' : '';

    return (
      <ItemRuntimeClock
        {...{
          duration,
          durationStyle: duration < 0 ? { color: '#f62459' } : {},
          fullscreen,
          description,
          descriptionTooltip: TooltipConstants.CSItemRunTime,
          onClick: this._handleToggleFullScreenClock,
        }}
      />
    );
  },

  _handleToggleFullScreenClock() {
    CuesheetCueClockActions.toggleFullScreenClock();
  },
});
